// src/components/CardProduct/CardProduct.js
// CẬP NHẬT FILE HIỆN TẠI

import { cloneElement, useContext, useState } from 'react';
import './CardProduct.scss';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import { Icon } from '../../icon/icon';
import { useDispatch } from 'react-redux';
import { fetchModule } from '../../../store/actions/module.action';
import { Popover } from 'antd';
import { openMessageError } from '../../common/Message/openMessageError';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../utils/string/cn.utils';

const CardProduct = ({
  md,
  title,
  description1,
  description2,
  onDragStart,
  onClick,
  active,
  ...props
}) => {
  // THÊM moduleType prop
  const designerPageContext = useContext(DesignerPageContext);
  const [isLoading, setIsLoading] = useState(false);
  const [module, setModule] = useState();
  const [isHover, setIsHover] = useState(false);

  const { t } = useTranslation();

  const dispatch = useDispatch();
  // ===== FUNCTION MỚI CHO CABINET SYSTEM =====
  const handleLoadCabinetModule = async (moduleData, moduleType) => {
    const { currentCabinetType, addCabinetModule } = designerPageContext;

    if (!currentCabinetType) {
      alert('Vui lòng chọn loại tủ trước khi thêm module!');
      return;
    }

    if (!moduleType) {
      alert('Vui lòng chọn loại module!');
      return;
    }
    setIsLoading(true);
    try {
      await addCabinetModule(moduleData, moduleData.moduleType);
    } catch (error) {
      console.error('Error loading cabinet module:', error);
      alert('Lỗi khi tải module!');
    } finally {
      setIsLoading(false);
    }
  };

  // ===== MAIN HANDLER =====
  const handleLoadModel = async moduleData => {
    const { currentCabinetType } = designerPageContext;

    if (currentCabinetType) {
      await handleLoadCabinetModule(moduleData, moduleData.moduleType);
    }
  };

  const loadModule = id => {
    setIsLoading(true);
    try {
      dispatch(fetchModule(id)).then(action => {
        if (action?.payload?.data) {
          const { data } = action.payload;
          setModule(data);
          handleLoadModel(data);
        } else throw Error('Unable to load!');
      });
    } catch (error) {
      openMessageError({ content: t(error?.message ?? '') });
      setIsLoading(false);
    }
  };

  // ===== RENDER =====
  return (
    <div
      {...props}
      className={`flex flex-col items-center rounded-[4px] bg-fills-white self-stretch hover:[&_.card-image]:border-outline-brand-primary [&_.card-image]:border-transparent ${isLoading ? 'loading' : ''} ${
        active
          ? '[&_.card-image]:border-outline-brand-primary'
          : '[&_.card-image]:border-transparent'
      }`}
      onClick={async e => {
        if (onClick) {
          setIsLoading(true);
          await onClick(e);
          setIsLoading(false);
        } else {
          if (md?.type !== undefined) return;
          if (!module) loadModule(md.id);
          else handleLoadModel(module);
        }

        setTimeout(() => {
          designerPageContext.setTick(t => t + 1);
        }, 200);
      }}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        opacity: isLoading ? 0.7 : 1,
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      {isHover ? (
        <Tooltip
          title={<span style={{ maxWidth: '200px' }}>{title}</span>}
          getPopupContainer={() => document.body}
          destroyOnHidden
          open
          placement="top"
        >
          <div
            className="flex gap-8 absolute left-0 right-0 items-center justify-center flex-col top-0 bottom-0"
            style={{ zIndex: -1 }}
          ></div>
        </Tooltip>
      ) : (
        <></>
      )}
      <div className="card-image border-[2px] border-solid rounded-[4px] h-[157px] overflow-hidden">
        <img
          src={md?.thumbnail_url ?? md?.icon ?? '/assets/icons/none.png'}
          alt=""
          onMouseDown={e => {
            e.preventDefault(); // Không để trình duyệt xử lý drag mặc định
            onDragStart?.(e, md); // callback từ trên truyền xuống
          }}
          className="object-cover h-full"
        />
        {md.ref_link ? (
          <Popover
            getTooltipContainer={() => document.body}
            placement="bottomLeft"
            classNames={{
              body: 'py-6 px-12 rounded-[4px]',
            }}
            styles={{
              body: { maxWidth: '280px' },
            }}
            content={
              <span className="text-body-medium" style={{ color: '#5A5D60' }}>
                {`${t('Product details')}: `}
                <a rel="noreferrer" href={md.ref_link} target="_blank">
                  {md.ref_link}
                </a>
              </span>
            }
          >
            <span
              className="w-16 h-16 flex absolute top-5 right-5"
              style={{ color: '#258FD2' }}
            >
              <Icon.ICInfoFill />
            </span>
          </Popover>
        ) : (
          <></>
        )}
      </div>

      <div className="flex p-8 flex-col items-center gap-4 self-stretch">
        {title && (
          <div className="flex items-start gap-6 self-stretch">
            <span className="text-body-medium-emphasized text-black-high line-clamp-1">
              {title}
            </span>
          </div>
        )}

        {description1 && (
          <div className="flex items-start gap-6 self-stretch line-clamp-2">
            <span className="text-body-small text-black-medium">
              {description1}
            </span>
          </div>
        )}
        {description2 && (
          <div className="flex items-start gap-6 self-stretch">
            <span className="text-supporting-xl text-nowrap text-black-medium">
              {description2}
            </span>
          </div>
        )}
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgba(255,255,255,0.9)',
            padding: '5px 10px',
            borderRadius: '4px',
            color: '#007bff',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          Loading...
        </div>
      )}
    </div>
  );
};

export default CardProduct;
